import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Hash 기반 라우팅 + 연령 인증 composable
 *
 * @param {string[]} validHashes - 허용할 hash 목록 (예: ['', 'ad-2026'])
 * @param {Function} onAuthenticated - 연령 인증 성공 후 실행할 콜백 (예: () => updatePage('ad-2026'))
 */
export function useHashRouter({ validHashes, onAuthenticated }) {
  const currentPage = ref(null)

  const updatePage = page => {
    location.hash = page !== '' ? `#${page}` : ''
    window.scrollTo(0, 0)
  }

  const updatePageFromHash = () => {
    const birthInfo = sessionStorage.getItem('birthInfo') || ''
    const savedBirthInfo = birthInfo ? JSON.parse(birthInfo) : null
    const hash = location.hash.replace('#', '')

    // 유효하지 않은 hash 진입 방어
    if (!validHashes.includes(hash)) {
      updatePage('')
      return
    }

    if ((savedBirthInfo && savedBirthInfo.age < 19) || (!savedBirthInfo && hash !== '')) {
      alert('만 19세 이상 이용 가능합니다.')
      sessionStorage.removeItem('birthInfo')
      updatePage('')
    } else {
      currentPage.value = null
      setTimeout(() => {
        currentPage.value = hash
      }, 10)
    }
  }

  function handleAdultCheck(result) {
    if (!result) {
      alert('만 19세 이상 이용 가능합니다.')
      return
    }
    onAuthenticated()
  }

  onMounted(() => {
    window.addEventListener('hashchange', updatePageFromHash)
    updatePageFromHash()
  })

  onUnmounted(() => {
    window.removeEventListener('hashchange', updatePageFromHash)
  })

  return { currentPage, updatePage, handleAdultCheck }
}
